export class CancellationReason {
    constructor(
        public id: string,
        public displayName: string,
        public orderIndex: number,
        public dateCreated: Date,
        public dateUpdated: Date,
        public isPublic: boolean = true
    ) { }
}
